<!-- 贷款记录 -->
<template>
  <div class='loan-record'>
    <van-tabs v-model="active" swipeable animated sticky color="#E3C194" line-width="50px" line-height="2px" title-inactive-color="#BEBEBE" title-active-color="#171717" @click="onTabs">
      <van-tab title="未完成">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="pad-side20">
          <van-empty image="search" description="暂无相关内容" v-if="pendingDataList.length === 0" />
          <div class="list-item" v-for="(item, index) in pendingDataList" :key="index">
            <div class="circle-num flex justify-content-end"><span class="align-self-end">{{index + 1}}</span></div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请产品</p>
              <p class="grey-text">{{item.productName}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请日期</p>
              <p class="grey-text">{{item.applyTime}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请金额</p>
              <p class="grey-text">{{item.loanAmount | mapMoney}}元</p>
            </div>
            <div class="row flex justify-content-between align-items-center" v-show="![1,2].includes(item.status*1) && item.creditAmount*1 > 0">
              <p>核准金额</p>
              <p class="grey-text">{{item.creditAmount | mapMoney}}元</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请编号</p>
              <p class="grey-text">{{item.applyNo}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>案件状态</p>
              <p class="orange-text">{{item.statusName}}</p>
            </div>
            <div class="row flex justify-content-center align-items-center">
              <input type="button" value="用款" class="lg-btn" @click="useLoan(index)">
            </div>
          </div>
        </div>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="已放款">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="pad-side20">
          <van-empty image="search" description="暂无相关内容" v-if="completDataList.length === 0" />
          <div class="list-item" v-for="(item, index) in completDataList" :key="index">
            <div class="circle-num flex justify-content-end"><span class="align-self-end">{{index + 1}}</span></div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请产品</p>
              <p class="grey-text">{{item.productName}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请日期</p>
              <p class="grey-text">{{item.applyTime}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请金额</p>
              <p class="grey-text">{{item.loanAmount | mapMoney}}元</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>核准金额</p>
              <p class="grey-text">{{item.creditAmount | mapMoney}}元</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请编号</p>
              <p class="grey-text">{{item.applyNo}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>案件状态</p>
              <p class="orange-text">{{item.statusName}}</p>
            </div>
            <div class="row flex justify-content-center align-items-center">
              <input type="button" value="查看详情" class="lg-btn" @click="readDetail(index)">
            </div>
          </div>
        </div>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="其他">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="pad-side20">
          <van-empty image="search" description="暂无相关内容" v-if="otherDataList.length === 0" />
          <div class="list-item" v-for="(item, index) in otherDataList" :key="index">
            <div class="circle-num flex justify-content-end"><span class="align-self-end">{{index + 1}}</span></div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请产品</p>
              <p class="grey-text">{{item.productName}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请日期</p>
              <p class="grey-text">{{item.applyTime}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请金额</p>
              <p class="grey-text">{{item.loanAmount | mapMoney}}元</p>
            </div>
            <div v-show="item.statusName != '拒绝'" class="row flex justify-content-between align-items-center">
              <p>核准金额</p>
              <p class="grey-text">{{item.creditAmount | mapMoney}}元</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>申请编号</p>
              <p class="grey-text">{{item.applyNo}}</p>
            </div>
            <div class="row flex justify-content-between align-items-center">
              <p>案件状态</p>
              <p class="orange-text">{{item.statusName}}</p>
            </div>
          </div>
        </div>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs, Empty, PullRefresh } from 'vant';
import { reqGetLoanProgress } from '@/api';
import { mapState } from 'vuex';

export default {
  name: 'LoanRecord',

  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Empty.name]: Empty,
    [PullRefresh.name]: PullRefresh
  },

  data () {
    return {
      active: 0,
      isLoading: false,
      pendingDataList: [],
      completDataList: [],
      otherDataList: [],
      statusList: {
        1: '待附件补件',
        2: '审核中',
        3: '额度待确认',
        4: '核准待面签',
        5: '核准待动用',
        6: '未通过',
        7: '已放款',
        8: '面签进行中',
        9: '未动用额度已过期',
        10: '额度已使用完毕',
        12: '已结清',
        16: '补件期限已过',
        99: '未定义状态',
      },
      isApply: false,
    };
  },
  filters: {
    mapMoney(money) {
      let num = money * 1
      return num.toLocaleString()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },

  created() {
    let applyResult = sessionStorage.getItem("applySuccess");
    if (applyResult && applyResult === '1') {
      this.isApply = true;
    }
    this.getList()
  },

  methods: {
    onRefresh() {
      this.getList().then(res => {
        this.$toast("刷新成功");
        this.isLoading = false;
      })
    },
    getList() {
      var _this = this;
      return new Promise((resolve, reject) => {
        reqGetLoanProgress({idNo: this.userInfo.idNo}).then(res => {
          this.dataList = res
          this.completDataList = []
          this.pendingDataList = []
          this.otherDataList = []
          res.forEach(item => {
            if(item.status*1 === 7) {
              this.completDataList.push(item)
            }else if(item.status <= 5 || item.status * 1 === 8) {
              this.pendingDataList.push(item)
            }else {
              this.otherDataList.push(item)
            }
          });
          if (_this.isApply && _this.active === 0 && _this.pendingDataList.length === 0) {
            _this.showApplyTip();
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    readDetail(index) {
      this.$store.commit('setLoanRecordDetail', {loanRecordDetail: this.completDataList[index]})
      this.$router.push("/loan-record-detail")
    },

    useLoan(index) {
      this.$dialog.alert({
        title: "提示",
        message: "请您下载APP完成用款",
        showCancelButton: true
      }).then(function () {
        // 点击确定执行
        // window.location.href = 'https://test.jmscfc.com:28087/Qrcode/#/downloadJmx';
		let baseUrl = process.env.VUE_APP_URL.split("JmxApi")[0];
		window.location.href = baseUrl + 'Qrcode/#/downloadJmx';
      }).catch(function () {
      });
    },

    onTabs(name, title) {
      if (name === 0) {
        if (this.isApply && this.active === 0 && this.pendingDataList.length === 0) {
          this.showApplyTip();
        }
      }
    },

    showApplyTip() {
      var _this = this;
      this.$dialog.alert({
        title: '提示',
        message: '您提交的申请系统审批中，请稍等刷新，审批结果将同步短信通知，请注意查收。',
        confirmButtonText: '客服电话',  // 本地化确认按钮文字提示内容
        cancelButtonText: '更新',
        showCancelButton: true
      }).then(() => {
        _this.showCusTel();
      }).catch(() => {
        _this.getList();
      });
    },

    showCusTel() {
      this.$dialog.alert({
        title: '客服电话',
        message: '400-876-9898',
      });
    },
  },
}

</script>

<style lang='less' scoped>
  .list-item {
    background:rgba(255,255,255,1);
    border:1px solid rgba(236,236,236,1);
    border-bottom: none;
    box-shadow:0px 9px 10px rgba(0,0,0,0.05);
    border-radius:3px;
    margin-top: 20px;
    padding-top: 28px;
    position: relative;
    overflow: hidden;
    .circle-num {
      content: "";
      position: absolute;
      top: -35px;
      left: -20px;
      width: 52px;
      height: 64px;
      border-radius: 50%;
      background: linear-gradient(137deg,rgba(246,193,122,1) 0%,rgba(255,222,174,1) 100%);
      padding: 6px 11px;
      font-weight: 800;
      box-sizing: border-box;
    }
    .row {
      padding: 12px 20px;
      border-bottom: 1px solid rgba(236,236,236,1);;
    }
    .grey-text {
      color: #BEBEBE;
    }
    .orange-text {
      color: #E3C194;
    }
    .lg-btn {
      width: 149px;
      line-height: 36px;
      font-size: 14px;
      margin: 3px 0;
      box-shadow: none;
    }
  }
</style>